import { useTranslation } from "react-i18next";
import { MAILCHIMP } from "../../config/mailchimp";

export function MailchimpTrialForm(props) {
    const { t } = useTranslation();

    const mailchimpTrialHTML =
        "<h2>" +
        t("trial-section-title") +
        "</h2>" +
        "<p>" +
        t("trial-section-text") +
        "</p>" +
        "<!-- Begin Mailchimp Signup Form -->" +
        '<div id="mc_embed_signup">' +
        `<form action="${MAILCHIMP.actionUrl("trial")}" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank">` +
        '<div id="mc_embed_signup_scroll">' +
        '<div class="mc-field-group">' +
        "<label for='mce-EMAIL' class='mc-field-group-label'>" +
        t("mailchimp-form-email-title") +
        "<span class='asterisk'>*</span>" +
        "</label>" +
        '<input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL" required>' +
        '<span id="mce-EMAIL-HELPERTEXT" class="helper_text"></span>' +
        `<div hidden=""><input type="hidden" name="tags" value="${MAILCHIMP.forms.trial.tag}"></div>` +
        "</div>" +
        '<div id="mergeRow-gdpr" class="mergeRow gdpr-mergeRow content__gdprBlock mc-field-group">' +
        '<div class="content__gdpr">' +
        "<h3>" +
        t("mailchimp-form-marketing-title") +
        "</h3>" +
        "<p>" +
        t("mailchimp-form-marketing-text") +
        "</p>" +
        '<fieldset class="mc_fieldset gdprRequired mc-field-group" name="interestgroup_field">' +
        "<label class='checkbox subfield' for='gdpr_136588'><input type='checkbox' id='gdpr_136588' name='gdpr[136588]' value='Y' class='av-checkbox gdpr'><span>" +
        t("mailchimp-form-email-label") +
        "</span> </label>" +
        "</fieldset>" +
        "<p>" +
        t("mailchimp-form-marketing-unsubscribe-text") +
        "</p>" +
        "</div>" +
        '<div class="content__gdprLegal">' +
        "<p>" +
        t("mailchimp-form-marketing-gdpr-agreement-text") +
        "</p>" +
        "</div>" +
        "</div>" +
        '<div id="mce-responses" class="clear">' +
        '<div class="response" id="mce-error-response" style="display:none"></div>' +
        '<div class="response" id="mce-success-response" style="display:none"></div>' +
        "</div>    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->" +
        `<div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="${MAILCHIMP.spamTrap}" tabindex="-1" value=""></div>` +
        "<div class='clear'><input type='submit' value=" +
        t("mailchimp-form-request-trial-label") +
        " name='subscribe' id='mc-embedded-subscribe' class='button' style='width:100%;margin-top:2rem !important'></div>" +
        "</div>" +
        "</form>" +
        "</div>" +
        "<script type='text/javascript' src='//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js'></script><script type='text/javascript'>(function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]='EMAIL';ftypes[0]='email';}(jQuery));var $mcj = jQuery.noConflict(true);</script>" +
        "<!--End mc_embed_signup-->";

    return (
        <div
            className={`mailchimp-form ${
                props.className ? props.className : ""
            }`}
            dangerouslySetInnerHTML={{ __html: mailchimpTrialHTML }}
        ></div>
    );
}
